module.exports = __webpack_public_path__ + "img/loading.f36c2ab6.svg";